import { useCacheData } from '~/hooks/reactQuery';
import { getAssetUrl } from '~/utils/asset';

export const useRecommendSearchKeywords = () => {
  return useCacheData(
    'recommend-search-keywords',
    async () => {
      const res = await fetch(
        getAssetUrl('files/marketplace-recommend-keyword-7', 'json'),
      );
      return (await res.json()) as { recommendKeywords: string[] };
    },
    { suspense: true },
  );
};

export const useECouponRecommendKeywords = () => {
  return useCacheData(
    'marketplace-e-coupon-recommend-keywords',
    async () => {
      const res = await fetch(
        getAssetUrl('files/marketplace-e-coupon-recommend-keywords', 'json'),
      );
      return (await res.json()) as { recommendKeywords: string[] };
    },
    { suspense: true, cacheTime: 0, staleTime: 0 },
  );
};
